import { DEVICES } from '../../constants'

export const getRedirectOptions = (admon, activeDynamicLayout) => {
  let redirectOptions = Object.assign({}, admon)
  Object.assign(redirectOptions, {
    fcid: admon.fcid[activeDynamicLayout],
    device: activeDynamicLayout === DEVICES.DESKTOP ? 'd' : 'm'
  })
  return redirectOptions
}
